import { render, staticRenderFns } from "./sayweee-operations.vue?vue&type=template&id=254bee8b&scoped=true&"
import script from "./sayweee-operations.vue?vue&type=script&lang=js&"
export * from "./sayweee-operations.vue?vue&type=script&lang=js&"
import style0 from "./sayweee-operations.vue?vue&type=style&index=0&id=254bee8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254bee8b",
  null
  
)

export default component.exports